/**
 * @generated SignedSource<<cd16f2cdf1e61dae3f60acf46ff7526e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalWorkItemSubtype = "APPROVAL" | "BUG" | "CATALOG_ITEM" | "DEFAULT_TASK" | "EPIC" | "INCIDENT" | "ISSUE" | "MILESTONE" | "OTHER" | "PROBLEM" | "QUESTION" | "REQUESTED_ITEM" | "SECTION" | "STORY" | "TASK" | "TICKET" | "WORK_ITEM" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphWorkItem_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly containerName: string | null;
  readonly entity: {
    readonly assignee?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly provider?: {
      readonly name: string | null;
    } | null;
    readonly status?: string | null;
    readonly subtype?: ExternalWorkItemSubtype | null;
    readonly workItemProject?: {
      readonly id: string | null;
      readonly name: string | null;
    } | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly permissionLevel: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphWorkItem_AtlassianSearchPage";
};
export type searchGraphWorkItem_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphWorkItem_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphWorkItem_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = [
  (v0/*: any*/),
  (v4/*: any*/)
],
v6 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": (v5/*: any*/)
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "subtype"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphWorkItem_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v6/*: any*/)
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": (v6/*: any*/)
            },
            {
              "concreteType": "ExternalWorkItemProject",
              "kind": "LinkedField",
              "name": "workItemProject",
              "plural": false,
              "selections": (v5/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "status"
            },
            (v7/*: any*/),
            {
              "concreteType": "ExternalProvider",
              "kind": "LinkedField",
              "name": "provider",
              "plural": false,
              "selections": [
                (v4/*: any*/)
              ]
            }
          ],
          "type": "ExternalWorkItem"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v7/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "c48e1a7829873d321d8869c7f94f2a97";

export default node;
